import { motion, useScroll, useSpring, useTransform } from "framer-motion";

// Thin bar pinned to the very top that tracks scroll depth, shifting from
// acid-yellow at the top through to red near the bottom.
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 28,
    restDelta: 0.001,
  });

  const backgroundColor = useTransform(
    scrollYProgress,
    [0, 0.55, 0.85, 1],
    ["#DFFF00", "#DFFF00", "#FF8A00", "#FF2A00"]
  );
  const boxShadow = useTransform(
    scrollYProgress,
    [0, 1],
    ["0 0 8px rgba(223,255,0,0.6)", "0 0 10px rgba(255,42,0,0.75)"]
  );

  return (
    <motion.div
      data-testid="scroll-progress-bar"
      aria-hidden="true"
      style={{ scaleX, backgroundColor, boxShadow }}
      className="fixed top-0 left-0 right-0 z-[100] h-[3px] origin-left"
    />
  );
}
